

<template>
  <div class="tel-actions">
    <p class="text">{{ $t('findPwd.t00001') }} <a class="btn" @click="showActions">{{ $t('openAccount.t000023') }}</a></p>
    <ActionSheet
      v-model="isShowActions"
      :cancel-text="$t('openAccount.t000028')"
      close-on-click-action>
      <div class="actions-box">
        <div class="item van-hairline--bottom" v-for="item in actionsList" :key="item.id" >
          <template v-if="isApp">
            <a @click="actionHand(item)">{{item.remark}}：{{item.value_display}}</a>
          </template>
          <!--          此处要区分是H5还是APP-->
          <template v-if="!isApp">
            <a :href="`${item.type}:${item.value}`">{{item.remark}}：{{item.value_display}}</a>
          </template>
        </div>
      </div>
    </ActionSheet>
  </div>
</template>

<script>
import { getBrowser } from "@/utils/browser";
import { ActionSheet } from "vant";

export default {
  components: { ActionSheet },
  data(){
    return {
      isApp: getBrowser().isApp,
      isShowActions: false,
      actionsList: []
    }
  },
  methods: {
    async showActions() {
      const all = [this.getEnum('customerServicePhone'), this.getEnum('customerServiceEmail')];
      Promise.all(all).then(data => {
        data[0].remark = this.$t('openAccount.t000029');
        data[0].type = 'tel';
        data[1].remark = this.$t('openAccount.t000030');
        data[1].type = 'mailto';
        this.actionsList = data;
        this.$nextTick(()=>{
          this.isShowActions = true;
        })
      })
    },
    getEnum(key){
      return new Promise((resolve) => {
        this.$apis.getEnum({
          key
        }).then(res => {
          resolve(res[0])
        })
      })
    },
    actionHand(item){
      const urls = {
        tel: 'callPhone',
        mailto: 'sendEmail'
      }
      this.$JsBridge.callHandler('jumpPage', {
        type: 2,
        url: urls[item.type],
        data: item.value
      })
    }
  }
}
</script>

<style scoped lang="less">
.tel-actions{
  text-align: center;
  margin: 20px 0;
  .text{
    a{
      color: #328CF4;
    }
  }
  .actions-box{
    padding: 0 20px;
    .item{
      display: flex;
      justify-content: center;
      line-height: 100px;
      font-size: 28px;
      a{
        color: #0F0F2F;
        font-weight: 400;
      }
    }
  }
}
.black-theme{
  .tel-actions{
    .actions-box{
      .item{
        a{
          color: #fff;
        }
      }
    }
  }
}
</style>